<template lang="pug">
Common.reset-password-verification-set-password(title="Set your password" :errors="errors")
  h1(slot="header") {{ title }}

  template(slot="main")
    SetPassword(
    :route="$app.api.Routes.Accounts.PasswordReset.GetSetPassword(this.$route.params.verificationKey)"
    :new-request="{ url: $site.Routes.ResetPassword.GetEmailVerification, message: \"Please enter a non-blank password\" }"
    set-password-message="Thank you for verifying your email address, we now need you to set a password for your account."
    @errors="onErrors")
</template>

<script>
import { Common, SetPassword } from "AccountPages/components";

export default {
  name: "ResetPasswordVerificationSetPassword",
  components: {
    Common,
    SetPassword,
  },
  data() {
    return {
      errors: [],
      title: "Set your new password",
    };
  },
  methods: {
    onErrors(errors) {
      this.errors = errors;
    },
  },
};
</script>
